import type { InputHTMLAttributes, ReactNode } from 'react';

interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'children'> {
  label: string;
  hint?: ReactNode;
}

export function Field({ label, hint, style, ...rest }: FieldProps) {
  return (
    <div>
      <label
        style={{
          fontSize: 12,
          color: 'var(--ink-soft)',
          fontWeight: 600,
          display: 'block',
          marginBottom: 6,
        }}
      >
        {label}
      </label>
      <input
        style={{
          width: '100%',
          padding: '12px 14px',
          background: 'var(--bg-card)',
          border: '1px solid var(--line)',
          borderRadius: 12,
          fontSize: 14,
          fontFamily: 'var(--sans)',
          color: 'var(--ink)',
          boxSizing: 'border-box',
          outline: 'none',
          ...style,
        }}
        {...rest}
      />
      {hint && (
        <div style={{ fontSize: 11, color: 'var(--ink-mute)', marginTop: 4 }}>{hint}</div>
      )}
    </div>
  );
}
